import React from 'react';
import Grid from '@material-ui/core/Grid';
import { styled } from '@material-ui/core';

import CircularProgress from '../../../CircularProgress/CircularProgress';

const CircularGrid = styled(Grid)({
  position: 'fixed',
  zIndex: 999999,
  height: '100%',
  width: '100%',
  '& svg circle': {
    stroke: '#c5281c',
  },
});

export const SpinnerScreen = () => (
  <CircularGrid container alignContent="center" justify="center">
    <CircularProgress />
  </CircularGrid>
);

export default SpinnerScreen;
